<template>
    <div class="dashboard-charts">
        <h2 class="heading">
            {{ graphHeading }}
        </h2>
        <base-table-spinner v-show="showSpinner"></base-table-spinner>
        <div v-show="!noRecordFound && !showSpinner" class="chart-container">
            <div :id="id" class="amcharts-div activity-timeline-report"></div>
        </div>

        <base-no-record-found v-show="noRecordFound"></base-no-record-found>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import _ from 'lodash'
    import resource from '@/api/resource'
    require('amcharts3')
    require('amcharts3/amcharts/serial')
    require('amcharts3/amcharts/pie')

    export default {
        // End of Component > watch
        /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
        props: {
            id: {
                type: String,
                default: null,
            },
            path: {
                type: String,
                required: true,
            },
            query: {
                type: Object,
                required: true,
            },
            reset: {
                type: Number,
                default: 0,
            },
            graphHeading: {
                type: String,
                required: true,
            },
        },
        /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
        data() {
            return {
                dataProvider: [],
                resourceApi: null,
                noRecordFound: false,
                showSpinner: true,
            }
        },

        /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
        computed: {
            ...mapGetters(['dataSegmentId']),
        }, // End of Component > methods

        /*
        |--------------------------------------------------------------------------
        | Component > watch
        |--------------------------------------------------------------------------
        */
        watch: {
            reset(value) {
                if (value) {
                    this.getStats()
                }
            },
            dataSegmentId(value) {
                if (value) {
                    this.noRecordFound = false
                    this.showSpinner = true
                    this.getStats()
                }
            },
        }, // End of Component > props

        /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
        mounted() {
            this.getStats()
        }, // End of Component > mounted
        /*
        |--------------------------------------------------------------------------
        | Component > created
        |--------------------------------------------------------------------------
        */
        created() {
            this.resourceApi = new resource(this.path)
        }, // End of Component > computed

        /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
        methods: {
            created() {
                window.AmCharts.makeChart(this.id, {
                    type: 'serial',
                    categoryField: 'category',
                    categoryType1: 'category-type-1',
                    categoryType2: 'category-type-2',
                    categoryType3: 'category-type-3',
                    rotate: false,
                    colors: [
                        '#00CC00',
                        '#C91F37',
                        '#B0DE09',
                        '#0D8ECF',
                        '#2A0CD0',
                        '#CD0D74',
                        '#CC0000',
                        '#00CC00',
                        '#0000CC',
                        '#DDDDDD',
                        '#999999',
                        '#333333',
                        '#990000',
                    ],
                    startDuration: 1,
                    color: '#1B1B1E',
                    fontFamily: 'ProximanovaRegular',
                    fontSize: 14,
                    categoryAxis: {
                        autoWrap: true,
                        gridPosition: 'start',
                        gridAlpha: 1,
                        gridColor: '#F2F2F6',
                    },
                    trendLines: [],
                    graphs: [
                        {
                            balloonText: '[[category-type-1]]: [[value]]',
                            fillAlphas: 1,
                            id: 'AmGraph-1',
                            title: 'graph 1',
                            type: 'column',
                            valueField: 'column-1',
                        },
                        {
                            balloonText: '[[category-type-2]]: [[value]]',
                            fillAlphas: 1,
                            id: 'AmGraph-2',
                            title: 'graph 2',
                            type: 'column',
                            valueField: 'column-2',
                        },
                        {
                            balloonText: '[[category-type-3]]: [[value]]',
                            fillAlphas: 1,
                            id: 'AmGraph-3',
                            title: 'graph 3',
                            type: 'column',
                            valueField: 'column-3',
                        },
                    ],
                    guides: [],
                    valueAxes: [
                        {
                            id: 'ValueAxis-1',
                            gridAlpha: 1,
                            gridColor: '#F2F2F6',
                            title: '',
                        },
                    ],
                    allLabels: [],
                    balloon: {},
                    titles: [],
                    dataProvider: this.dataProvider,
                })
            }, // created() method end

            async getStats() {
                try {
                    this.query.dataSegmentId = this.dataSegmentId
                        ? this.dataSegmentId
                        : localStorage.getItem('activeDataSegmentId')
                    if (this.query.dataSegmentId) {
                        let { data } = await this.resourceApi.list(this.query)
                        this.showSpinner = false

                        if (data && data.data) {
                            console.log('---------',data.data)
                            this.dataProvider = []
                            let graphData = data.data
                            this.noRecordFound = false


                            this.dataProvider.push({
                                category: 'Idenfo Verifications Status',
                                'category-type-1': 'Approved',
                                'category-type-2': 'High Risk',
                                'category-type-3': 'Pending',
                                'column-1': graphData.completed,
                                'column-2': graphData.risk,
                                'column-3': graphData.pending,
                            })
                            // this.dataProvider.push({
                            //     category: `Pending`,
                            //     'category-type-1':
                            //         'Total',
                            //     'column-1': graphData.pending,
                            // })
                            // this.dataProvider.push({
                            //     category: `High Risk`,
                            //     'category-type-1':
                            //         'Total',
                            //     'column-1': graphData.risk,
                            // })
                        } else {
                            this.noRecordFound = true
                        }

                        this.created()
                    }
                } catch (error) {
                    console.log(error)
                    this.$store.commit('setError', error)
                }
            }, // getStats() methods end
        }, // End of Component > created
    } // End of export default
</script>
